import { VpButton, VpIcon } from '@vtmn-play/react';
import { useTranslation } from 'react-i18next';
import './errorPage.css';

const cleanStorageAndReload = () => {
  // TODO : replace by StorageHelper
  localStorage.clear();
  window.location.assign('/personal-offer');
};

export interface ErrorPageProps {
  errorPageTitle: string;
  errorMessage?: string;
}

export const ErrorPage = ({
  errorPageTitle = 'Oopsie...',
  errorMessage,
}: ErrorPageProps) => {
  const { t } = useTranslation();
  return (
    <div className="error-page-container">
      <VpIcon name="emotion-sad" />
      <div className="error-title">{errorPageTitle}</div>
      {errorMessage && <div className="error-message">{errorMessage}</div>}
      <VpButton shape="squared" onClick={() => cleanStorageAndReload()}>
        {t('reload')}
      </VpButton>
    </div>
  );
};
